<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card class="mt-6" elevation="6">
        <div class="pa-3">
          <div class="grid_half">
            <div class="grid_sidebyside">
              <div class="ma-6">
                <div class="ml-1">เลขที่ใบสั่งซื้อ</div>
              </div>
              <div class="mt-6 ml-5 detail_mobile">
                {{ po_data.po_code }}
              </div>
              <div class="ma-6">
                <div class="ml-1">บริษัท</div>
              </div>
              <div class="mt-6 ml-5 detail_mobile">
                {{ po_data.supplier_name }}
              </div>
            </div>
            <div>
              <div class="ma-6">
                <div class="grid_vat">
                  <div class="ml-1">
                    <div>ภาษีมูลค่าเพิ่ม :</div>
                  </div>
                  <div class="mr-1">
                    <div class="ml-3" v-if="po_data.type_vat == 0">
                      ภาษีรวมใน
                    </div>
                    <div class="ml-3" v-if="po_data.type_vat == 1">
                      ภาษีแยกนอก
                    </div>
                    <div class="ml-3" v-if="po_data.type_vat == 2">
                      ไม่กระทบภาษี
                    </div>
                    <div class="ml-3" v-if="po_data.type_vat == 3">
                      ภาษีเป็น 0
                    </div>
                  </div>
                </div>
              </div>
              <div class="ma-6 pt-6">
                <div class="grid_vat">
                  <div class="ml-1">การสั่งซื้อ :</div>
                  <div class="ml-3" v-if="po_data.po_type == 0">
                    เงินสด
                  </div>
                  <div class="ml-3" v-if="po_data.po_type == 1">
                    เครดิต
                  </div>
                </div>
              </div>
            </div>
            <div class="grid_sidebyside">
              <div class="ma-6">
                <div class="ml-1">แผนก</div>
              </div>
              <div class="mt-6 ml-5 detail_mobile">
                <div v-if="po_data.sup_department !== null">{{ po_data.sup_department }}</div>
                <div v-else>-</div>
              </div>
            </div>
          </div><br>
          <v-divider></v-divider>
          <div class="pa-4">
            <span style="font-size: 24px">รายการสินค้า</span>
          </div>
          <div class="pa-2">
            <v-data-table :headers="Headers" :items="po_list" :search="search" key="index" mobile-breakpoint="0" hide-default-footer items-per-page="100">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.index +1 }}</td>
                  <td>{{ dataDetail.item.product_code }}</td>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td>{{ dataDetail.item.unit_name }}</td>
                  <td>
                    <div class="ma-6 ml-1">
                      {{ format_number(dataDetail.item.qty) }}
                    </div>
                  </td>
                  <td>
                    <div class="ma-3 ml-1">
                      {{ format_price(dataDetail.item.price) }}
                    </div>
                  </td>
                  <td>
                    <div class="ma-3 ml-1" v-if="dataDetail.item.discount_unit != null">{{ format_price(dataDetail.item.discount_unit) }}</div>
                    <div class="ma-3 ml-1" v-if="dataDetail.item.discount_unit == null">0.00</div>
                  </td>
                  <td>
                    <div class="ma-3 ml-1" v-if="dataDetail.item.discount != null">{{ format_price(dataDetail.item.discount) }}</div>
                    <div class="ma-3 ml-1" v-if="dataDetail.item.discount == null">0.00</div>
                  </td>
                  <td>{{ format_price(dataDetail.item.total) }}</td>
                </tr>
              </template>
              <template v-slot:body.append>
                <tr class="total_color">
                  <td colspan="6" class="border_col"></td>
                  <td colspan="1" class="pa-2 border_col">
                    <div class="ma-4">
                      <div class="text_total">จำนวนเงินทั้งสิ้นรวมภาษี</div>
                    </div>
                  </td>
                  <td colspan="2" class="pa-2 border_col">
                    <div class="ma-4">
                      <div class="text-center">{{ sub_total }}</div>
                    </div>
                  </td>
                </tr>
                <tr class="discount_color">
                  <td colspan="6" class="border_col"></td>
                  <td colspan="1" class="pa-2 border_col">
                    <div class=" ma-4">
                      <div class="text_total">ส่วนลด %</div>
                    </div>
                  </td>
                  <td colspan="2" class="pa-2 border_col">
                    <div class="ma-4">
                      <div class="text-center" v-if="po_data.discount_percent !== null && po_data.discount_percent !== ''">{{ format_price(po_data.discount_percent) }}</div>
                      <div class="text-center" v-else>0</div>
                    </div>
                  </td>
                </tr>
                <tr class="discount_color">
                  <td colspan="6" class="border_col"></td>
                  <td colspan="1" class="pa-2 border_col">
                    <div class=" ma-4">
                      <div class="text_total">ส่วนลด(บาท)</div>
                    </div>
                  </td>
                  <td colspan="2" class="pa-2 border_col">
                    <div class="ma-4">
                      <div>
                        <div v-if="po_data.discount_unit !== null && po_data.discount_unit !== '' && po_data.discount_unit !== 0" class="text-center">{{ format_price(po_data.discount_unit) }}</div>
                        <div v-else class="text-center">0.00</div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="discount_color">
                  <td colspan="6" class="border_col"></td>
                  <td colspan="1" class="border_col">
                    <div class="ml-2 mb-7 text_total">มูลค่าสินค้า</div>
                    <div class="ml-2 pt-1 text_total">ภาษีมูลค่าเพิ่ม 7%</div>
                  </td>
                  <td colspan="2" class="pa-2 border_col">
                    <div class="ma-4 text-center">{{ no_vat }}</div>
                    <v-divider/>
                    <div class="ma-4 text-center">{{ cal_vat }}</div>
                  </td>
                </tr>
                <tr class="total_color">
                  <td colspan="6" class="border_col"></td>
                  <td colspan="1" class="pa-2 border_col">
                    <div class="ma-4">
                      <div class="text_total">รวมเงินทั้งสิ้น</div>
                    </div>
                  </td>
                  <td colspan="2" class="pa-2 border_col">
                    <div class="ma-4">
                      <div class="text-center">{{ total_all }}</div>
                    </div>
                  </td>
                </tr>
                <v-divider/>
              </template>
            </v-data-table>
            <div class="pa-4">
              <div class="mb-4">
                หมายเหตุ
              </div>
              <div v-if="po_data.note != null">{{ po_data.note }}</div>
              <div v-if="po_data.note == null">-</div>
            </div>
            <div class="pa-4" v-if="po_data.status === 2">
              <div class="mb-4">
                หมายเหตุการยกเลิกใบสั่งซื้อ
              </div>
              <div v-if="po_data.note_cancel != null">{{ po_data.note_cancel }}</div>
              <div v-if="po_data.note_cancel == null">-</div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {formatNumber,formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Purchase_details",
  data() {
    return {
      loading_page: false,
      search: null,
      Headers: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          width: '100px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'code',
          fixed: true,
          width: '130px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'count',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ราคา',
          value: 'price',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ส่วนลด(บาท)',
          value: 'discount_unit',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ส่วนลด(%)',
          value: 'discount_percent',
          fixed: true,
          width: '170px',
        },
        {
          text: 'รวม',
          value: 'total',
          fixed: true,
          width: '120px',
        },
      ],
      po_list: [],
      po_data: {
        po_code: null,
        sup_department: null,
        supplier_id: null,
        supplier_name: null,
        po_type: null,
        type_vat: null,
        note: null,
        note_cancel: null,
        status: null,
        discount_percent: 0,
        discount_unit: 0,
      }
    }
  },
  methods: {
    format_price: function (value) {
      return formatPrice(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    getPO_list() {
      this.loading_page = true
      HTTP.post('/purchaseorders/getpolists', {
        po_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.po_data.po_code = res.data.object.po.po_code
          this.po_data.sup_department = res.data.object.po.sup_department
          this.po_data.supplier_id = res.data.object.po.supplier_id
          this.po_data.supplier_name = res.data.object.po.supplier_name
          this.po_data.po_type = res.data.object.po.po_type
          this.po_data.type_vat = res.data.object.po.type_vat
          this.po_data.note = res.data.object.po.note
          this.po_data.note_cancel = res.data.object.po.cancel_note
          this.po_data.status = res.data.object.po.status
          this.po_data.discount_percent = res.data.object.po.discount_percent
          this.po_data.discount_unit = res.data.object.po.discount
          this.po_list = res.data.object.po_lists

          console.log(res.data)
        }
      })
    },
  },
  computed: {
    sub_total() {
      // let data_list = this.po_list;
      // const result = data_list.reduce((sum,number) => {
      //   let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //   if (total_all < 0) {
      //     return sum + 0;
      //   }
      //   else {
      //     return sum + total_all;
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let data_list = this.po_list;
      const result = data_list.reduce((sum,number) => {
        return sum + number.total
      }, 0);
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    no_vat() {
      // let discount_percent = this.po_data.discount_percent;
      // let discount_unit = this.po_data.discount_unit;
      // let data_list = this.po_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.po_data.type_vat == 0){
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     let in_vat = ((total_all * 7)/107);
      //     let total = total_grand - in_vat
      //     if (total < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total;
      //     }
      //   }
      //   else if(this.po_data.type_vat == 1) {
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total_grand;
      //     }
      //   }
      //   else if(this.po_data.type_vat == 2) {
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total_grand;
      //     }
      //   }
      //   else if(this.po_data.type_vat == 3) {
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total_grand;
      //     }
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");


      let discount_percent = this.po_data.discount_percent;
      let discount_unit = this.po_data.discount_unit;
      let data_list = this.po_list;
      const subTotal = data_list.reduce((sum,number) => {
        return sum + number.total;
      },0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;
      
      if(this.po_data.type_vat == 0) {
        let before_vat = total_discount * (100/107);
        return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
        return total_discount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    cal_vat() {
      // let data_list = this.po_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.po_data.type_vat == 0) {
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let calculate = ((total_all * 7)/107);
      //     return sum + (calculate);
      //   }
      //   else if (this.po_data.type_vat == 1){
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let calculate = (total_all * (7 / 100));
      //     return sum + (calculate);
      //   }
      //   else if (this.po_data.type_vat == 2) {
      //     let calculate = 0;
      //     return sum + (calculate);
      //   }
      //   else if (this.po_data.type_vat == 3) {
      //     let calculate = 0;
      //     return sum + (calculate);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");


        let discount_percent = this.po_data.discount_percent;
        let discount_unit = this.po_data.discount_unit;
        let data_list = this.po_list;
        const subTotal = data_list.reduce((sum,number) => {
          return sum + number.total;
        },0);

        let percent = (parseFloat(subTotal) * discount_percent) / 100;
        let total_percent = parseFloat(subTotal) - percent;
        let total_discount = total_percent - discount_unit;

        if(this.po_data.type_vat == 0) {
          let result_vat = total_discount * (7/107);
          return result_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else if (this.po_data.type_vat == 1){
          let result_vat = total_discount * (7/100);
          return result_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else{
          let zero = 0
          return zero.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    total_all() {
      // let discount_percent = this.po_data.discount_percent;
      // let discount_unit = this.po_data.discount_unit;
      // let data_list = this.po_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.po_data.type_vat == 0){
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total_grand;
      //     }
      //   }
      //   else if (this.po_data.type_vat == 1){
      //     let total = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total * discount_percent) / 100)
      //     let total_final = total - dis_percent
      //     let total_grand = total_final - discount_unit
      //     let ex_vat = ((total) * (7/100))
      //     let total_all = total_grand + ex_vat
      //     if (total_all < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + (total_all);
      //     }
      //   }
      //   else if (this.po_data.type_vat == 2){
      //     let total = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total * discount_percent) / 100)
      //     let total_final = total - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + (total_grand)
      //     }
      //   }
      //   else if (this.po_data.type_vat == 3){
      //     let total = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total * discount_percent) / 100)
      //     let total_final = total - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + (total_grand)
      //     }
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let result_vat = 0;
      let total_result = 0;
      let discount_percent = this.po_data.discount_percent;
      let discount_unit = this.po_data.discount_unit;
      let data_list = this.po_list;
      const subTotal = data_list.reduce((sum,number) => {
        return sum + number.total
      }, 0);
      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;
      if (this.po_data.type_vat == 1){
          result_vat = total_discount * (7/100);
          total_result = total_discount + result_vat;
      }else{
          total_result = total_discount;
      }

      return total_result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    this.getPO_list();
  }
}
</script>

<style scoped>
.text_total {
  font-size: 14px;
}
.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}
.discount_input >>> input {
  text-align: end;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_sidebyside {
  display: grid;
  grid-template-columns: 30% 70%;
}
.grid_vat {
  display: grid;
  grid-template-columns: 30% 70%;
}
.input_width {
  width: 100%;
}
.discount_color {
  background-color: rgb(225 248 251);
}
.total_color {
  background-color: #e1ffb8;
}
@media only screen and (max-width: 1100px) {
  .grid_sidebyside {
    display: grid;
    grid-template-columns: 45% 55%;
  }
  .grid_vat {
    display: grid;
    grid-template-columns: 45% 55%;
  }
  .detail_mobile {
    margin-left: 15px!important;
  }
}
@media only screen and (max-width: 650px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_sidebyside {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_vat {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .detail_mobile {
    margin-top: -10px!important;
    margin-left: 45px!important;
  }
}
</style>
